import { Pipe, PipeTransform } from '@angular/core';
import { getRoleLabel } from '../utils/role-label';

@Pipe({
    name: 'roleLabel',
    standalone: false
})
export class RoleLabelPipe implements PipeTransform {
  transform(role: string | null | undefined): string {
    return getRoleLabel(role);
  }
}
